module.exports = __webpack_public_path__ + "img/close_icon.4f3280d7.svg";